import axios from "axios";
import { getQueryString } from "../utils/function";
// import moment from "moment";
const devEnv = process.env.NODE_ENV !== "production";

const API = axios.create({
  baseURL: `${
    devEnv ? process.env.REACT_APP_DEV_API : process.env.REACT_APP_PROD_API
  }`,
  withCredentials: true
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("accessToken")) {
    req.headers.Authorization = `Bearer ${localStorage.getItem("accessToken")}`;
  }
  return req;
});
// Authors
export const signUp = (formData) =>
  API.post("/auth/send-verification-code", formData);
export const signIn = (formData) => API.post("/auth/login", formData);
export const logout = () => API.post("/auth/logout");
export const changePassword = (data) =>
  API.post("/admin/change-password", data);
export const alertNotification = (data) =>
  API.post("/admin/send-alert-notification", data);
export const editAlertNotification = (data) =>
  API.patch("/admin/edit-alert-notification", data);
export const changeEmail = (data) => API.patch("/admin", data);

export const getAdmin = () => API.get("/admin");

export const getFileUrl = (data) => API.post("/upload", data);

export const getUserss = (page = 0, search, queryParams, userType) => {
  const urlParams = new URLSearchParams();

  if (search !== "") {
    urlParams.append("search", search);
  }

  if (queryParams) {
    Object.keys(queryParams).forEach((key) => {
      urlParams.append(key, queryParams[key]);
    });
  }
  const query = getQueryString({
    skip: page * 9,
    take: 9,
    isPurchased: userType === "Paid" ? true : userType === "Unpaid" ? false : ""
  });
  const url = `/users?${query}&${urlParams.toString()}`;

  return API.get(url);
};
export const getUserList = (id) => {
  if (!id) {
    throw new Error("ID is required to fetch user list");
  }

  const url = `/organizations/${id}/progress`;

  return API.get(url);
};

export const getUserKycList = (id, createdBy) => {
  if (!id) {
    throw new Error("ID is required to fetch user list");
  }
  if (!createdBy) {
    throw new Error("createdBy is required to fetch user list");
  }

  const url = `/kyc?kycId=${id}&createdBy=${createdBy}`;
  return API.get(url);
};
export const getUsers = (
  page = 0,
  pageSize = 8,
  search = "",
  queryParams = {},
  type = "",
  createdBy = ""
) => {
  const urlParams = new URLSearchParams();

  // Append search query if provided
  if (search.trim()) {
    urlParams.append("search", search);
  }

  // Append additional query params dynamically
  Object.keys(queryParams).forEach((key) => {
    urlParams.append(key, queryParams[key]);
  });

  // Define base query parameters
  const baseQuery = {
    skip: page * pageSize,
    take: pageSize,
    type: type
  };

  // Conditionally add isPurchased filter
  if (type === "Paid") {
    baseQuery.isPurchased = true;
  } else if (type === "Unpaid") {
    baseQuery.isPurchased = false;
  }

  // Construct final query string
  const query = getQueryString(baseQuery);
  const url = `/organizations?${query}&${urlParams.toString()}&createdBy=${createdBy}`;

  return API.get(url);
};

//kyc data
export const getUsersKyc = (
  page = 0,
  pageSize = 8,
  search = "",
  queryParams = {},
  type = "",
  createdBy = ""
) => {
  const urlParams = new URLSearchParams();

  // Append search query if provided
  if (search.trim()) {
    urlParams.append("search", search);
  }

  // Append additional query params dynamically
  Object.keys(queryParams).forEach((key) => {
    urlParams.append(key, queryParams[key]);
  });

  // Define base query parameters
  const baseQuery = {
    skip: page * pageSize,
    take: pageSize,
    type: type
  };

  // Conditionally add isPurchased filter
  if (type === "Paid") {
    baseQuery.isPurchased = true;
  } else if (type === "Unpaid") {
    baseQuery.isPurchased = false;
  }

  // Construct final query string
  const query = getQueryString(baseQuery);
  const url = `/kyc?${query}&${urlParams.toString()}&createdBy=${createdBy}`;

  return API.get(url);
};

export const getRefineryById = (goldConsignmentId) => {
  return API.get(
    `/gold-consignments?afterRefined=true&goldConsignmentId=${goldConsignmentId}`
  );
};

//add user list for organization
export const getOrganizationsByType = (type) => {
  return API.get(
    `/organizations?type=${type}&kYCStatus=Approved&createdBy=admin&unassignedOrganization=true`
  ); // Adjust endpoint if needed
};

// refinery request
export const getRefineryReq = (
  page = 0,
  pageSize = 8,
  search = "",
  queryParams = {},
  type = ""
) => {
  const urlParams = new URLSearchParams();

  // Append search query if provided
  if (search.trim()) {
    urlParams.append("search", search);
  }

  // Append additional query params dynamically
  Object.keys(queryParams).forEach((key) => {
    urlParams.append(key, queryParams[key]);
  });

  // Define base query parameters
  const baseQuery = {
    skip: page * pageSize,
    take: pageSize,
    type: type
  };

  // Construct final query string
  const query = getQueryString(baseQuery);
  const url = `/gold-consignments?afterRefined=true&${query}&${urlParams.toString()}`;

  return API.get(url);
};

//reject req for user registation
export const verifyOrRejectUser = (userId, verificationStatus, body = {}) => {
  console.log(userId, verificationStatus, "sdhucdyfsvuvyubdbvfdyhuba");
  return API.patch(
    `/admin/verify-user-organization-request?organizationId=${userId}&verificationStatus=${verificationStatus}`,
    body
  );
};

// kyc status for approved and reject
export const verifyOrRejectKyc = (organizationId, body = {}) => {
  return API.patch(`/admin/verify-kyc-request/${organizationId}`, body);
};
// verify refinery data
// api.js
export const verifyOrRejectRefinery = (
  shipmentId,
  refinedStatus,
  body = {}
) => {
  // Build query params
  const params = new URLSearchParams({
    shipmentId,
    adminApprovedRefinedData: String(body.status),
    refinedStatus
  });

  // Forward the body unmodified
  return API.patch(`/admin/approve-refined?${params.toString()}`, body);
};

export const particularUserData = (
  id,
  type,
  page = 0,
  pageSize = 8,
  search = "",
  queryParams = {},
  userType
) => {
  const urlParams = new URLSearchParams();

  // Append search query if provided
  if (search.trim()) {
    urlParams.append("search", search);
  }

  // Append additional query params dynamically
  Object.keys(queryParams).forEach((key) => {
    urlParams.append(key, queryParams[key]);
  });

  // Define base query parameters
  const baseQuery = {
    type: type,
    skip: page * pageSize,
    take: pageSize
  };

  // Conditionally add isPurchased filter
  if (userType === "Paid") {
    baseQuery.isPurchased = true;
  } else if (userType === "Unpaid") {
    baseQuery.isPurchased = false;
  }

  // Construct final query string
  const query = getQueryString(baseQuery);
  const url = `/organization/${id}?${query}&${urlParams.toString()}`;

  return API.get(url);
};
export const getAlertNotification = () => {
  return API.get("/admin/alert-notification");
};

// Add Sub admin API's
export const addSubAdmin = (form) => API.post("/sub-admin/register", form);

export const getSubAdmins = (page = 0, search) =>
  API.get(
    `/sub-admin?skip=${page * 8}&take=8${
      search === "" ? "" : `&search=${search}`
    }`
  );

// change user password
export const changeUserPassword = (form) =>
  API.patch("/admin/change-user-password", form);

// block user
export const blockUserAndSuspendById = (id, blockLabel) =>
  API.patch(
    `/admin/update-user-status?userId=${id}&status=${
      blockLabel === "Unblock"
        ? "Active"
        : blockLabel === "Reinstate"
        ? "Active"
        : blockLabel === "Block"
        ? "Blocked"
        : blockLabel
    }`
  );

// csv download button
export const getCsv = (start, end) => {
  const query = new URLSearchParams();

  if (start) query.append("startDate", start);
  if (end) query.append("endDate", end);

  const url = `/organizations/export-csv?${query.toString()}`;
  return API.get(url, {
    responseType: "blob"
  });
};

// csv for kyc download button
export const downloadKycCsv = (status = "") => {
  const query = new URLSearchParams();
  if (status) query.append("kycStatus", status);

  return API.get(`/kyc/export-csv?${query.toString()}`, {
    responseType: "blob"
  });
};

// csv for refinery download button
export const downloadRefineryCsv = (status = "") => {
  const query = new URLSearchParams();
  if (status) query.append("refinedStatus", status);

  return API.get(`gold-consignments/export-csv?${query.toString()}`, {
    responseType: "blob"
  });
};

// register user
export const registerUsers = (form) => API.post("/admin/create-user", form);
// export const registerUsers = (form) => API.post("/admin/create-sub-user", form);

// addmine
export const registerUser = (form) => API.post("/organizations", form);
// register checklist
export const registerChecklist = (form) =>
  API.post("/documentation-checklists", form);

// owenership
export const beneficialOwner = (form) => API.post("/beneficial-owners", form);

//Acknowledgment
export const acknowledgment = (form) =>
  API.post("/acknowledgment-declaration", form);

// riskassesment
export const riskAssesment = (form) =>
  API.post("/compliance-risk-assessments", form);

// kyc
export const kycSubmit = (form) => API.post("/kyc", form);

// update user
// export const updateUser = (form) =>
//   API.patch(`/admin/update-user-by-admin/${userId}`, form);
export const updateUser = (userId, form) =>
  API.patch(`/admin/update-user-by-admin/${userId}`, form);

// genarate jwt token as a user
export const generateJwt = (form) => API.post("/auth/generate-jwt-token", form);
// goldprices global
export const getGoldPrices = () => API.get("/users/global-gold-price");